let hamburger = document.getElementById("hamburger");
let hamburgermenu = document.getElementById("hamburger-menu");

hamburger.addEventListener("click", () => {
    if(hamburgermenu.classList.contains("hidden")){
        hamburgermenu.classList.remove("hidden");
    } else {
        hamburgermenu.classList.add("hidden");
    }
})